import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyPublicHoneymoon = loadable(() => import(/* webpackChunkName: "content/honeymoon" */ './PublicHoneymoonApp'), 'PublicHoneymoonApp');
